import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';

import { filter } from 'rxjs/operators';

import { ExternalBundlesLoader } from '@core/common-legacy';

export type AccountSetupBundleName = 'growsumo';

export type GrowsumoData = {
  email: string;
  name: string;
  companyId: number;
};

@Injectable({ providedIn: 'root' })
export class AccountSetupBundles extends ExternalBundlesLoader<AccountSetupBundleName> {
  public document = inject(DOCUMENT);

  constructor() {
    super(document);
  }

  public sendGrowsumo(growsumoData: GrowsumoData): void {
    const growsumoInstance = this.getInstance('growsumo')!;
    growsumoInstance.status$.pipe(filter(status => status.loaded)).subscribe(_ => {
      const growsumo = (<any>window).growsumo;
      const { name, email, companyId } = growsumoData;
      growsumo.data.email = email;
      growsumo.data.name = name;
      growsumo.data.customer_key = companyId;
      growsumo.createSignup();
    });
  }
}
